<template>
  <div class="grid grid-cols-12 gap-2" v-bind="$attrs">
    <div class="col-span-7 truncate">
      <span>{{ description }}</span>
      <span v-if="optionDescription" class="text-sm">
        ({{ optionDescription }})
      </span>
    </div>
    <div class="col-span-2 text-center">
      {{ quantity }}
    </div>
    <div class="col-span-3 text-right">
      {{ formatCurrency(amount ?? 0) }}
    </div>
  </div>
</template>
<script setup lang="ts">
import useLocalization from '@/modules/useLocalization';

interface Props {
  description: string;
  amount: number | null | undefined;
  quantity?: number;
  optionDescription?: string | null | undefined;
  labelFor?: string | null | undefined;
}

const props = defineProps<Props>();
const { formatCurrency } = useLocalization();
</script>
